import { Component, ViewChild, ViewEncapsulation } from '@angular/core';

import { GoogleMapComponent } from './google-map/google-map.component';
import { TrainOptionComponent } from './train-option/train-option.component';
import { TrainDetailComponent } from './train-detail/train-detail.component';
import { TrainAttractionComponent } from './train-attraction/train-attraction.component';

import { MapTrainService } from '../../services/map-train.service';
import { catchError, throwError } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';


//定義資料型態
interface placeLocation {
  position:  google.maps.LatLngLiteral;
  name:      string;
  address:   string;
}

@Component({
  selector: 'map-train',
  standalone: true,
  imports: [GoogleMapComponent,TrainOptionComponent,TrainDetailComponent,TrainAttractionComponent],
  styleUrl: '../../static/css/layout.css',
  templateUrl: './map-train.component.html',
  encapsulation: ViewEncapsulation.None
})

export class MapTrainComponent {


  /*--------------------組件與服務初始化-------------------*/

  // [mapComponent] 子組件
  @ViewChild(GoogleMapComponent) mapComponent: GoogleMapComponent;

  @ViewChild(TrainAttractionComponent) attractionComponent: TrainAttractionComponent;

  // [MapTrainService] 定義服務
  constructor(private mapService: MapTrainService) {
  }




  /*--------------------頁面顯示資料-------------------*/

  /**
   * 0:起訖點選擇           (搜尋框顯示)
   * 1:旅運規劃優先級選擇    (搜尋框、搜尋選項顯示)
   * 2:呼叫API的錯誤頁面    (搜尋框、搜尋選項、錯誤提示顯示)
   * 3:結果路線選擇         (路線選擇框顯示、地圖資訊顯示)
   * 4:路線結果             (路線結果顯示、地圖資訊顯示)
   * */
  state: number = 0;

  //僅限state = 2 時，需要顯示的錯誤訊息
  errorMessage :string = "";

  //[Autocomplete]物件，綁定[startPoint]
  startAutoPlace: google.maps.places.Autocomplete;


  //[Autocomplete]物件，綁定[endoint]
  endAutoPlace: google.maps.places.Autocomplete;


  //給API的[起點資料]
  startLocation: placeLocation = {
    position: null,
    name:"",
    address:""
  };

  //給API的[終點資料]
  endLocation: placeLocation = {
    position: null,
    name:"",
    address:""
  };

  //API傳回的所有路線結果
  detailArray:any;

  //當前顯示的路線結果
  detailObject:any;


  attractionArray:any;


  /************* ngAfterViewInit()頁面載入完成-------------------*/
  //將[input]綁定到[Autocomplete]物件，並偵測[place_change]事件

  ngAfterViewInit() {

    //獲取[input]
    const startInput = document.getElementById("startPoint") as HTMLInputElement;
    const endInput = document.getElementById("endPoint") as HTMLInputElement;

    //[google map api] 引入 [librarys]
    google.maps.importLibrary("places").then(() => {

      //定義台中市地圖邊界
      const taichungBounds= new google.maps.LatLngBounds(
        new google.maps.LatLng(24.045, 120.516),
        new google.maps.LatLng(24.245, 120.846)
      );

      //[搜尋功能-基本設定]
      //限制地區範圍:[台灣]、[台中市]
      const options: google.maps.places.AutocompleteOptions = {
        bounds: taichungBounds,
        componentRestrictions: { country: "tw" },
        //回傳欄位
        fields: ["geometry", "name","formatted_address"],
        strictBounds: true,
      };

      //[startAutoPlace]:綁定對應[input]的[Autocomplete]物件
      this.startAutoPlace = new google.maps.places.Autocomplete(startInput, options);
      this.startAutoPlace.addListener('place_changed', () => {
        this.startLocation = {
          name: this.startAutoPlace.getPlace().name,
          address: this.startAutoPlace.getPlace().formatted_address,
          position: {
            lat: this.startAutoPlace.getPlace().geometry.location.lat(),
            lng: this.startAutoPlace.getPlace().geometry.location.lng()
          }
        };

        startInput.value = this.startLocation.name;

        //判斷是否進入下一階段
        this.checkState();
      });

      //[endAutoPlace]:綁定對應[input]的[Autocomplete]物件
      this.endAutoPlace = new google.maps.places.Autocomplete(endInput, options);
      this.endAutoPlace.addListener('place_changed', () => {

        this.endLocation = {
          name: this.endAutoPlace.getPlace().name,
          address: this.endAutoPlace.getPlace().formatted_address,
          position: {
            lat: this.endAutoPlace.getPlace().geometry.location.lat(),
            lng: this.endAutoPlace.getPlace().geometry.location.lng()
          }
        };
        endInput.value = this.endLocation.name;

        //判斷是否進入下一階段
        this.checkState();
      });

    });

  }

  /******************** changePlace()對調起終點-------------------*/
  changePlace(){

    const startInput = document.getElementById("startPoint") as HTMLInputElement;
    const endInput = document.getElementById("endPoint") as HTMLInputElement;

    const temp = this.startLocation;
    this.startLocation = this.endLocation;
    this.endLocation = temp;

    startInput.value = this.startLocation.name;
    endInput.value =  this.endLocation.name
  }

  /***************** changePlace()判斷起點終點是否都有值-------------------*/
  checkState(){
    if(this.startLocation.position != null && this.endLocation.position != null){
      this.state = 1;
    }
  }



 /***************** showDetail()呼叫TDX旅運規劃API-------------------*/
  showDetail(option:any){
    this.mapService.getDetail(this.startLocation.position,this.endLocation.position,option)
    .pipe(
      catchError((error: HttpErrorResponse) => {
        //顯示錯誤訊息
        this.errorMessage= "服務異常，請稍後重試";
        this.state = 2;

        return throwError(() => error);
      })
    )
    .subscribe((detailArray:any) => {
      if(detailArray.length == 0 ){
        //顯示錯誤訊息
        this.errorMessage= "找不到結果";

        this.state = 2;
      }else{

        //接收API資料
        this.detailArray = detailArray;

        //預設顯示第一筆資料
        //[註]:僅在需要顯示時呼叫相關[Map api]並寫入至[Object]，避免重複呼叫增加成本
        this.detailArray[0].mapInfo = this.getMapInfo(this.detailArray[0],0);
        this.detailObject = detailArray[0];


        //呼叫[地圖子組件]的changeCenter()，將地圖中心設定為起點及終點中心
        var lat = (this.startLocation.position.lat + this.endLocation.position.lat) /2;
        var lng = (this.startLocation.position.lng + this.endLocation.position.lng) /2;
        this.mapComponent.changeCenter(lat,lng);

        this.getMapAttraction();

        this.state = 3;
      }
    });
  }

 /***************** 彈出錯誤訊息-------------------*/
  //彈出錯誤訊息後，點擊任一地方返回上一步
  checkWarn(){
    if(this.state == 2){
      this.state = 1;
    }
  }


  detailBack(state:number,num:number){
    this.state = 1;


    if (typeof this.detailArray[num].mapInfo === 'undefined') {
      this.detailArray[num].mapInfo = this.getMapInfo(this.detailArray[num],num);
    }

    this.detailObject = this.detailArray[num];


    let lat = (this.startLocation.position.lat + this.endLocation.position.lat) /2;
    let lng = (this.startLocation.position.lng + this.endLocation.position.lng) /2;
    this.mapComponent.changeCenter(lat,lng);

    this.state = state;

  }




  getMapAttraction(){
    this.mapService.getAttraction(this.endLocation.position.lat,this.endLocation.position.lng,environment.trainSize)
    .pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      })
    )
    .subscribe((detailArray:any) => {
      this.attractionArray = detailArray;
    });
  }


  getMapInfo(detail:any,num:number){
    console.log(detail);
    let polylines = [];
    let mapMarkers = [];

    let startMarker = this.getMapMarker(3,this.startLocation.position,"","ic_RouteStart.svg",20);
    let endMarker = this.getMapMarker(3,this.endLocation.position,"","ic_RouteEnd.svg",20);
    mapMarkers.push(startMarker);
    mapMarkers.push(endMarker);

    let lastType : string = "";
    detail.sections.forEach(async (section:any, index:number) => {
      let polyline : any = {};
      let mapMarker : any = {};
      switch(section.type){
        case "pedestrian-station":
        case "waiting":
          break;
        case "pedestrian":
        case "drive":
        case "cycle":
          if(lastType != "" && lastType != "transit" && lastType != "pedestrian-station" && lastType != "waiting"){
            mapMarker = this.getMapMarker(2,section.departure.place.location,section.departure.place.name,"",0);
            mapMarkers.push(mapMarker);
          }
          //當轉乘距離超過指定範圍時，再使用API
          if(section.travelSummary.length > environment.googleAPIUsed){
            lastType = section.type;
            let mapData  = await this.mapService.getPolylineGoogle(section,section.type);
            polyline = this.getPolylineDot(mapData.polyline);
            this.detailArray[num].sections[index].data = mapData.data;
          }else{
            polyline = this.getPolylineDot(this.mapService.getPolylinePoint(section));
            this.detailArray[num].sections[index].data = [];
          }
          polylines.push(polyline);
          break;
        case "transit":
          let endMarker: any = {};
          switch(section.transport.mode){

            case "TRA":
              mapMarker = this.getMapMarker(2,section.departure.place.location,section.departure.place.name,"mapic_tra.svg",35);
              endMarker = this.getMapMarker(2,section.arrival.place.location,section.arrival.place.name,"mapic_tra.svg",35);
              let path = environment.hereAPIUsed ? await this.mapService.getPolylineTra(section) : this.mapService.getPolylineStop(section);
              polyline = this.getPolylineColor(path,"#005397");
              break;

            case "HighwayBus":
              mapMarker = this.getMapMarker(2,section.departure.place.location,section.departure.place.name,"mapic_nhpt.svg",35);
              endMarker = this.getMapMarker(2,section.arrival.place.location,section.arrival.place.name,"mapic_nhpt.svg",35);
              polyline = this.getPolylineColor(this.mapService.getPolylineStop(section),"#ee4659");
              break;

            case "Bus":
              mapMarker = this.getMapMarker(2,section.departure.place.location,section.departure.place.name,"mapic_bus.svg",35);
              endMarker = this.getMapMarker(2,section.arrival.place.location,section.arrival.place.name,"mapic_bus.svg",35);
              polyline = this.getPolylineColor(this.mapService.getPolylineStop(section),"#1c96d5");
              break;

            case "MRT":
              mapMarker = this.getMapMarker(2,section.departure.place.location,section.departure.place.name,"mapic_mrt.svg",35);
              endMarker = this.getMapMarker(2,section.arrival.place.location,section.arrival.place.name,"mapic_mrt.svg",35);
              polyline = this.getPolylineColor(this.mapService.getPolylineMrt(section),"#8dc21f");
              break;

            case "HSR":
              mapMarker = this.getMapMarker(2,section.departure.place.location,section.departure.place.name,"mapic_thsr.svg",35);
              endMarker = this.getMapMarker(2,section.arrival.place.location,section.arrival.place.name,"mapic_thsr.svg",35);
              polyline = this.getPolylineColor(this.mapService.getPolylineStop(section),"#ca4f0f");
              break;

            default:
              mapMarker = this.getMapMarker(2,section.departure.place.location,section.departure.place.name,"",0);
              endMarker = this.getMapMarker(2,section.arrival.place.location,section.arrival.place.name,"",0);
              polyline = this.getPolylineColor(this.mapService.getPolylineStop(section),"#000000");
              break;

          }
          polylines.push(polyline);
          if(lastType != ""){
            mapMarkers.push(mapMarker);
          }

          if(section.intermediateStops != null){
            for (let stop of section.intermediateStops) {
              mapMarkers.push(this.getMapMarker(1,stop.departure.place.location,"","m_station.svg",10));
            }
          }


          if(detail.sections.length > index + 1 &&  detail.sections[index + 1].type != "transit"){
            mapMarkers.push(endMarker);
          }
          break;

        default:
          break;
      }

      lastType = section.type;

    });


    return {
      polylines : polylines,
      mapMarkers : mapMarkers
    };

  }

  //[polyline][虛線] (path:路徑)
  getPolylineDot(path:any){

    let iconPath = {
      path: 'M0,3.8L0,3.8c-0.8,0-1.4-0.6-1.4-1.4v-4.7c0-0.8,0.6-1.4,1.4-1.4h0c0.8,0,1.4,0.6,1.4,1.4v4.7C1.4,3.1,0.8,3.8,0,3.8z',
      fillColor: '#319165',
      fillOpacity: 1,
      strokeOpacity: 0,
      scale:2
    };

    return {
      path: path,
      options:{
        strokeOpacity: 0,
        icons: [{
          icon: iconPath,
          offset: '15px',
          repeat:'30px'
        }],
      }
    }
  }

  //[polyline][實線] (path:路徑)(color:顏色)
  getPolylineColor(path:any,color:string){

    return {
      path: path,
      options: {
        strokeOpacity: 1,
        strokeColor: color,
        strokeWeight: 4
      }
    }
  }

  //[mapMarker](zIndex:上下層)(position:座標)(name:名稱)(img:圖片名稱)(size:圖片大小)
  getMapMarker(zIndex:number,position:any,name:string,img:string,size:number){

    //建立圖標
    let divElement = document.createElement('div');
    divElement.className ="site";
    if(name!=null && name.length != 0){
    divElement.style.minWidth= "80px";
    divElement.style.width = (name.length * 15) + "px";
    }

    if(img != ""){
      let imgElement = document.createElement('img');

      imgElement.src = "/static/images/svg/" + img;
      imgElement.style.width = size + "px";
      divElement.appendChild(imgElement);
    }

    if(name!=null && name.length != 0){

      let pElement = document.createElement('p');
      pElement.textContent= name;
      divElement.appendChild(pElement);
    }

    return {
      zIndex: zIndex,
      position:position,
      options:{
        content: divElement,
        gmpClickable: true,
      }
    };
  }



}
